/**
 * Formate une date (string ou null) en une chaîne de caractères lisible en français.
 * Retourne 'N/A' si la date est nulle ou invalide.
 * @param date La date à formater (peut être string | null | undefined).
 */
export const formatDate = (date?: string | null): string => {
  if (!date) return "N/A";
  const d = new Date(date);
  return isNaN(d.getTime())
    ? "Date invalide"
    : d.toLocaleDateString("fr-FR", {
        year: "numeric",
        month: "long",
        day: "numeric",
      });
};

/**
 * Statuts valides pour les Cadrages
 */
export type CadrageStatus = 'draft' | 'validated' | 'planned' | 'progress' | 'forge' | 'deployed';

/**
 * Retourne les classes CSS Tailwind correspondantes pour un statut de cadrage donné.
 * @param status Le statut du cadrage.
 */
export const statusToColor = (status: CadrageStatus | string | undefined | null): string => {
  switch (status) {
    case "validated":
      return "bg-green-100 text-green-800";
    case "deployed":
      return "bg-blue-100 text-blue-800";
    case "draft":
      return "bg-gray-100 text-gray-800";
    case "planned":
      return "bg-yellow-100 text-yellow-800";
    case "progress":
      return "bg-orange-100 text-orange-800";
    case "forge":
      return "bg-purple-100 text-purple-800";
    default:
      return "bg-gray-100 text-gray-800";
  }
};

/**
 * Retourne le libellé lisible en français pour un statut de cadrage donné.
 * @param status Le statut du cadrage.
 */
export const statusToLabel = (status: CadrageStatus | string | undefined | null): string => {
  switch (status) {
    case "validated":
      return "Validé";
    case "deployed":
      return "Déployé";
    case "draft":
      return "Brouillon";
    case "planned":
      return "Planifié";
    case "progress":
      return "En cours";
    case "forge":
      return "En Forge";
    default:
      return status || "Inconnu";
  }
};
